import React from "react";
import { object, array } from "prop-types";
import HeroImage from "../../atoms/heroImage";
import StoryHeadline from "../../atoms/story-headline";
import "./smallStoryCardWithTopBorder.m.css";

const SmallStoryCardWithTopBorder = ({ story, width }) => {
  return (
    <div styleName="card-container">
      <div styleName="column first-col">
        <HeroImage story={story} width={width} />
      </div>
      <div styleName="column">
        <StoryHeadline story={story} />
      </div>
    </div>
  );
};

SmallStoryCardWithTopBorder.propTypes = {
  story: object,
  width: array
};

export default SmallStoryCardWithTopBorder;
